/* District Bangle — consent.js
   Cookie banner wired to Shopify's Customer Privacy API (visitorConsent), plus a
   once-per-visitor timed newsletter popup. Both remember their state so they
   don't nag. Nothing shows until JS runs (progressive, non-blocking). */
const store = {
  get(k) { try { return localStorage.getItem(k); } catch (_) { return null; } },
  set(k, v) { try { localStorage.setItem(k, v); } catch (_) {} },
};

/* ---- cookie consent ---- */
const cookie = document.querySelector('[data-cookie]');
if (cookie && !store.get('db:consent')) {
  cookie.hidden = false;
  const decide = (allow) => {
    store.set('db:consent', allow ? 'granted' : 'declined');
    cookie.hidden = true;
    try {
      if (window.Shopify && Shopify.customerPrivacy) {
        Shopify.customerPrivacy.setTrackingConsent(allow, function () {});
      }
    } catch (_) {}
  };
  cookie.querySelector('[data-cookie-accept]')?.addEventListener('click', () => decide(true));
  cookie.querySelector('[data-cookie-decline]')?.addEventListener('click', () => decide(false));
}

/* The merchant's "Show the popup" choice decides WHERE the seen-flag lives, and
   that is the whole difference between the three options: localStorage outlives
   the tab (once per visitor), sessionStorage dies with it (once per session),
   and no store at all means nothing is ever remembered (every visit). */
function popupStore(frequency) {
  if (frequency === 'always') return { get() { return null; }, set() {} };
  const area = frequency === 'session' ? 'sessionStorage' : 'localStorage';
  return {
    get(k) { try { return window[area].getItem(k); } catch (_) { return null; } },
    set(k, v) { try { window[area].setItem(k, v); } catch (_) {} },
  };
}

/* ---- newsletter popup ---- */
const popup = document.querySelector('[data-popup]');
const seen = popup ? popupStore(popup.dataset.popupFrequency) : null;
if (popup && !seen.get('db:popup')) {
  const root = popup.closest('[data-consent-root]');
  const delay = (parseFloat(popup.dataset.popupDelay) || 0) * 1000;
  const close = () => { popup.hidden = true; seen.set('db:popup', 'seen'); };
  const open = () => {
    popup.hidden = false;
    popup.querySelectorAll('[data-popup-close]').forEach((el) => el.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); }, { once: true });
    const input = popup.querySelector('input[type="email"]');
    if (input) input.focus();
  };
  // If the form already posted successfully, don't re-show.
  if (popup.querySelector('[role="status"]')) { seen.set('db:popup', 'seen'); }
  else { setTimeout(open, delay); }
}
